import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import isInternalLink from 'src/common/utils/isInternalLink';
import ExternalLink from '../ExternalLink';

type Props = {
  activeClassName?: string;
  className?: string;
  to: string;
  openInNewTab?: boolean;
  'data-test'?: string;
  tabIndex?: number;
};

const UniversalLink: FC<Props> = ({
  children,
  className,
  activeClassName,
  openInNewTab = false,
  to,
  'data-test': dataTest,
  ...rest
}) => (isInternalLink(to) ? (
  <NavLink
    to={to}
    className={className}
    activeClassName={activeClassName}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </NavLink>
) : (
  <ExternalLink
    to={to}
    className={className}
    openInNewTab={openInNewTab}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </ExternalLink>
));

export default UniversalLink;
